var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.193,
    height: 13.935,
    viewBox: "0 0 12.193 13.935",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-share-alt",
    "data-name": "Icon awesome-share-alt",
    d: "M9.58,8.709a2.6,2.6,0,0,0-1.627.569L5.164,7.535a2.628,2.628,0,0,0,0-1.134L7.953,4.657A2.608,2.608,0,1,0,7.029,3.18L4.24,4.923a2.613,2.613,0,1,0,0,4.088l2.789,1.743A2.613,2.613,0,1,0,9.58,8.709Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.6c8829f2ba74bc5fdef027f967e3dcdf.svg";
export { ForwardRef as ReactComponent };